import { FEATURE_TO_TIERS } from '@/constants/features';
import { TIER } from '@/constants/price';

function getTiersForFeature(featureName) {
  return FEATURE_TO_TIERS[featureName] || [TIER.PRO, TIER.PREMIUM];
}

export default getTiersForFeature;
